import i18n from 'i18next';
import Cookie from 'js-cookie';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';
import 'intl-pluralrules';

import { DEFAULT_LOCALE, NEXT_LOCALE_COOKIE_NAME } from './constants/configEnums';
import translationENUS from '../../public/locales/en-US/translation.json';
import translationZH from '../../public/locales/zh-Hans/translation.json';

/**
 * Intl.PluralRules is necessary to support pluralization of strings. It isn't natively supported by
 * older browsers such as Safari 12, older FF, and pre-Chromium Edge.
 */

const resources = {
  'en-US': {
    translation: translationENUS,
  },
  'zh-Hans': {
    translation: translationZH,
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(ICU)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    fallbackLng: DEFAULT_LOCALE,
    lng: DEFAULT_LOCALE,
    supportedLngs: ['en-US', 'zh-Hans'],
    debug: false,
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `../../public/locales/{{lng}}/{{ns}}.json`,
      savePath: '../../public/locales/{{lng}}/{{ns}}.json',
    },
  })
  .catch((error) => {
    return error;
  });

export const changeLocale = (code = '') => {
  void i18n.changeLanguage(code).then(() => {
    const lng = i18n?.language || DEFAULT_LOCALE;
    Cookie.set(NEXT_LOCALE_COOKIE_NAME, lng);
    // set locale in html tag for conditional styles
    if (document) document.documentElement.lang = lng;
  });
};

export default i18n;
